import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { State, STATES } from '../../util/states';


@Injectable()
export class StateResolver implements Resolve<State> {
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): State {
    const stateCode = route.paramMap.get('state');
    return STATES.find(s => s.stateCode === stateCode);
  }
}
